module.exports = __webpack_public_path__ + "static/media/selfi.0e1ed516.jpeg";